import {defineStore} from 'pinia';
import {getFromLocalStorage, saveToLocalStorage} from '@/utils/local.storage.utils';

const STORAGE_KEY = import.meta.env.VITE_FAVORITES_STORAGE_KEY;
const URL_PARAM_KEY = import.meta.env.VITE_URL_PARAMS_FAVORITES_KEY;

type Favorites = {
	[key: string]: number;
}

type FavoriteProductStoreState = {
	favorites: Favorites;
	favoriteViewActive: boolean;
}

export const useFavoriteProductStore = defineStore('favorite-products', {
	state: (): FavoriteProductStoreState => ({
		favorites: getFromLocalStorage(STORAGE_KEY) || {},
		favoriteViewActive: false
	}),

	getters: {
		isFavorite: state => (productId: string) => state.favorites[productId] !== undefined,

		favoriteAmount: state => Object.keys(state.favorites).length
	},

	actions: {
		addToFavorites(productId: string) {
			this.favorites[productId] = 1;
			saveToLocalStorage(STORAGE_KEY, this.favorites);
		},

		removeFromFavorites(productId: string) {
			delete this.favorites[productId];
			saveToLocalStorage(STORAGE_KEY, this.favorites);
		},

		clear() {
			this.favorites = {};
			saveToLocalStorage(STORAGE_KEY, this.favorites);
		},

		toggleFavoriteView() {
			this.favoriteViewActive = !this.favoriteViewActive;
		},

		getFavoritesAsQueryParams() {
			if (this.favoriteViewActive) {
				const favoriteParams = Object.keys(this.favorites)
					.map(productId => `&${URL_PARAM_KEY}=${productId}`)
					.join('');

				return favoriteParams ?? '';
			}

			return '';
		}
	}
});
